<template>
  <a-modal class="resume_guide_modal" v-model:open="visible" @cancel="handleCancel" :footer="null">
    <template #title>
      Hi, {{ store.state.currentAccount.firstName + ' ' + store.state.currentAccount.lastName }}</template
    >
    <div class="tip">
      <span>Please complete the following information to create your personalized resume.</span>
    </div>
    <a-form class="modal_form" ref="formRef" :model="formState">
      <a-form-item
        validateTrigger="submit"
        label=""
        name="jobStatus"
        :rules="[{ required: true, message: 'Please select the type of work first' }]"
      >
        <div class="form_label">What type of work are you seeking?</div>
        <a-select
          class="resume_select"
          v-model:value="formState.jobStatus"
          size="large"
          placeholder="Please choose"
          :popupClassName="'resume_select_dropdown'"
        >
          <a-select-option v-for="item in JOB_STATUS_OPTIONS" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        validateTrigger="submit"
        label=""
        name="city"
        :rules="[{ required: true, message: 'Please select city' }]"
      >
        <div class="form_label">What kind of work are you looking for, and where?</div>
        <CityInputItem @on-change="handleChangeCity" class="resume_select" :isShowAll="false" />
      </a-form-item>
      <a-form-item
        validateTrigger="submit"
        label=""
        name="jobSkills"
        :rules="[{ required: true, message: 'Select Your Desired Position' }]"
      >
        <div class="resume_position_wrapper" @click="handleOpenPositionModal">
          <span :style="{ opacity: formState.jobSkills.length > 0 ? 1 : 0.5 }">{{
            formState.jobSkills.length > 0 ? formState.jobSkills[0].jobCategoryName : 'Desired Position'
          }}</span>
          <div class="skill_wrapper" v-if="formState.jobSkills[0]">
            <span class="skill_item" v-for="(data, indexS) in formState.jobSkills[0].jobSkills" :key="indexS">{{
              data.jobCategoryName
            }}</span>
          </div>
          <DownOutlined class="arrow_icon" />
        </div>
      </a-form-item>
      <div class="btn_wrapper">
        <button type="button" class="resume_btn upload_btn" :disabled="isSubmitDisabled" @click="handleUploadFileClick">
          <img src="@/assets/images/ai_resume_white.svg" alt="upload" />Upload resume
          <input type="file" ref="fileInput" style="display:none" @change="handleFileChange" />
        </button>
        <button type="primary" class="resume_btn next_btn" :disabled="isSubmitDisabled" @click="handleResumeNext">
          <img src="@/assets/images/arrow_right_white.svg" alt="Next" />Next
        </button>
      </div>
    </a-form>
    <div class="resume_action_wrapper">
      <div class="item" @click="helpVisible = true">
        <img src="@/assets/images/for_help.svg" alt="" class="icon" />
        <p class="label">Help</p>
      </div>
    </div>
  </a-modal>
  <PositionModal ref="PositionModalRef" @select-item="handleSelectPositionItem" />
  <!-- process modal -->
  <a-modal
    class="resume_guide_modal"
    title="AI is running"
    v-model:open="processVisible"
    :closable="false"
    :maskClosable="false"
    :footer="null"
  >
    <div class="process_bar">
      <div class="process_rate" :style="{ width: processRate + '%' }"></div>
    </div>
    <div class="process_text">
      <span class="text">Please wait a moment</span>
      <span class="process">{{ processRate }}%</span>
    </div>
  </a-modal>
  <!-- help modal -->
  <a-modal
    class="resume_guide_modal evaluation_modal"
    v-model:open="helpVisible"
    @cancel="
      helpVisible = false;
      helpStep = 1;
    "
    :footer="null"
  >
    <template v-if="helpStep == 1" #title>
      Help
    </template>
    <template v-else-if="helpStep == 2" #title>
      Send email
    </template>
    <div v-if="helpStep == 1">
      <div class="section_wrapper">
        <div class="section" @click="handleHelpSection('email')">
          <div>
            <img class="label_icon" src="@/assets/images/help_email.svg" />
            <span>Send an email to invite someone for help</span>
          </div>
          <div class="label_description">
            Fill in his/her email address, and JoyJobs will send an email invitation to the other party to help you
            complete your resume.
          </div>
          <img class="arrow_icon" src="@/assets/images/arrow_right.svg" />
        </div>
        <div class="section" @click="handleHelpSection('link')">
          <div>
            <img class="label_icon" src="@/assets/images/help_link.svg" />
            <span>Copy Resume Editing Link</span>
          </div>
          <div class="label_description">
            Copy the link and send it to the person who will help you fill it out
          </div>
          <img class="arrow_icon" src="@/assets/images/arrow_right.svg" />
        </div>
      </div>
    </div>
    <div v-else-if="helpStep == 2">
      <a-form class="resume_form" ref="formHelpRef" :model="formHelpState" layout="vertical" style="margin: 30px auto;">
        <EmailInputItem @change-email="handleChangeEmail" />
      </a-form>
      <a-button
        class="submit_btn"
        type="primary"
        @click="handleSubmitEmailHelp"
        :disabled="isSubmitDisabled"
        :loading="isSendingHelp"
      >
        Send
        <img v-if="!isSendingHelp" class="btn_icon" src="@/assets/images/airplane.svg" />
      </a-button>
    </div>
  </a-modal>
  <!-- Error modal -->
  <a-modal
    class="resume_guide_modal error_modal"
    v-model:open="errorVisible"
    @cancel="errorVisible = false"
    :footer="null"
  >
    <img src="@/assets/images/smile_modal.svg" class="confirm_icon" alt="" />
    <div class="confirm_text">{{ confirmText }}</div>
    <div class="btn_wrapper">
      <a-button class="confirm_btn" type="primary" @click.prevent="errorVisible = false">
        OK, I got it
      </a-button>
    </div>
  </a-modal>
</template>

<script setup>
import { DownOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { ref, defineExpose, reactive, toRaw } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { uploadResume, submitResumeIntention, sendResumeHelp, generateHelpToken } from '@/api/resume.js';
import CityInputItem from '@/components/CityInputItem.vue';
import EmailInputItem from '@/components/EmailInputItem.vue';
import PositionModal from '@/components/PositionModal.vue';
import { JOB_STATUS_OPTIONS } from '@/constants/jobStatus.js';

const errorVisible = ref(false);
const confirmText = ref();

const store = useStore();
const visible = ref(false);
const formState = reactive({
  jobStatus: null,
  city: '',
  jobSkills: [],
});
const isSubmitDisabled = ref(false);
const isSendingHelp = ref(false);
const PositionModalRef = ref(null);
const handleOpenPositionModal = () => {
  PositionModalRef.value.open();
};
const handleSelectPositionItem = (positionItem, skillItem) => {
  const positionState = {
    jobCategoryId: positionItem.categoryId,
    jobCategoryName: positionItem.categoryName,
    level: positionItem.level,
    jobSkills: [],
  };
  formState.jobSkills[0] = positionState;

  if (!skillItem) {
    return;
  }

  for (const data of skillItem) {
    const skillState = {
      jobCategoryId: data.categoryId,
      jobCategoryName: data.categoryName,
      level: data.level,
    };
    formState.jobSkills[0].jobSkills.push(skillState);
  }
};
const handleCancel = () => {
  visible.value = false;
};
const open = () => {
  visible.value = true;
};

const handleChangeCity = (item) => {
  formState.city = item;
};

const fileInput = ref(null);
const formRef = ref(null);
const router = useRouter();
const handleUploadFileClick = () => {
  fileInput.value && fileInput.value.click();
};
const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) {
    errorVisible.value = true;
    confirmText.value = 'Please upload your resume image/PDF.';
    return;
  }
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', 1);
  formData.append('jobStatus', formState.jobStatus);
  formData.append('city', formState.city);
  formData.append('jobSkills', JSON.stringify(formState.jobSkills));
  handleProcessInit();
  uploadResume(formData).then((res) => {
    handleProcessComplete();
    if (res.code == 0) {
      message.success(res.msg);
      handleCancel();
      router.push({
        name: 'EditResume',
        query: { t: Date.now() },
      });
    } else if (res.code == 30001) {
      errorVisible.value = true;
      confirmText.value = 'Currently only resume content recognition is supported. Please upload the correct resume.';
    } else if (res.code == 30013) {
      errorVisible.value = true;
      confirmText.value = 'Please upload your resume image/PDF.';
    } else if (res.code == 10001) {
      errorVisible.value = true;
      confirmText.value =
        'There seems to be an issue with the system. Please use the manual creation function for now.';
    } else {
      message.error(res.msg);
    }
  });
};
const handleResumeNext = () => {
  formRef.value.validate().then(() => {
    isSubmitDisabled.value = true;
    submitResumeIntention(toRaw(formState)).then((res) => {
      if (res.code == 0) {
        message.success(res.msg);
        handleCancel();
        router.push({
          name: 'EditResume',
          query: { t: Date.now() },
        });
      } else {
        message.error(res.msg);
      }
      isSubmitDisabled.value = false;
    });
  });
};

const processVisible = ref(false);
const processRate = ref(0);
const handleProcessInit = () => {
  processRate.value = 0;
  processVisible.value = true;
  const interval = setInterval(() => {
    processRate.value += 1;
    if (processRate.value >= 100) {
      clearInterval(interval);
      handleProcessComplete();
    }
  }, 500);
};
const handleProcessComplete = () => {
  processRate.value = 100;
  processVisible.value = false;
  fileInput.value.files = new DataTransfer().files;
};

// help logic
const helpVisible = ref(false);
const formHelpRef = ref(null);
const helpStep = ref(1);
const formHelpState = reactive({
  email: '',
});
const handleChangeEmail = (email) => {
  formHelpState.email = email;
};
const handleHelpSection = (type) => {
  if (type === 'email') {
    helpStep.value = 2;
  } else if (type === 'link') {
    generateHelpToken().then((res) => {
      if (res.code == 0) {
        handleCopyContact(res.data);
      } else {
        message.error(res.msg);
      }
    });
  }
};
const handleCopyContact = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard
      .writeText(text)
      .then(() => message.success('Copy successful'))
      .catch(() => {
        message.error('Copy Failed');
      });
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      message.success('Copy successful');
    } catch (err) {
      message.error('Copy Failed');
    } finally {
      document.body.removeChild(textarea);
    }
  }
};
const handleSubmitEmailHelp = () => {
  formHelpRef.value.validate().then(() => {
    isSubmitDisabled.value = true;
    isSendingHelp.value = true;
    sendResumeHelp({ email: formHelpState.email })
      .then((res) => {
        if (res.code == 0) {
          message.success(res.msg);
          helpVisible.value = false;
        } else {
          message.error(res.msg);
        }
      })
      .finally(() => {
        isSubmitDisabled.value = false;
        isSendingHelp.value = false;
      });
  });
};

defineExpose({
  open,
});
</script>

<style lang="less">
.resume_guide_modal {
  color: #05644f;
  font-size: 16px;
  .ant-modal-content {
    border-radius: 20px;
    padding: 32px;
  }
  .ant-modal-title {
    color: #05644f;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
  }
  .ant-modal-close-icon {
    color: #05644f;
  }
  .tip {
    font-weight: 300;
    width: 60%;
    font-size: 12px;
    margin-bottom: 25px;
    color: #888;
    .link {
      font-weight: bold;
      color: #5271ff;
      margin-left: 10px;
    }
  }
  .modal_form {
    .form_label {
      color: #333333;
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .resume_select {
      margin-right: 15px;
      min-width: 120px;
      .ant-select-selector {
        border: 1px solid rgba(5, 100, 79, 0.5);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
        color: #05644f;
        border-radius: 16px;
        padding: 0 24px;
        box-shadow: none !important;
        font-size: 14px;
        .ant-select-selection-item {
          color: #05644f;
        }
        .ant-select-selection-placeholder {
          opacity: 0.5;
          color: #05644f;
        }
      }
      .ant-select-arrow {
        color: #05644f;
        font-size: 14px;
      }
      &:hover .ant-select-selector,
      &.ant-select-focused .ant-select-selector {
        border: 1px solid rgba(5, 100, 79, 0.5) !important;
      }
    }
    .city_select {
      .ant-select-selection-placeholder {
        line-height: 35px !important;
      }
    }
    .btn_wrapper {
      display: flex;
      justify-content: space-between;
      gap: 20px;
      margin-top: 30px;
      .resume_btn {
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        border: none;
        padding: 10px;
        flex: 1;
        border-radius: 100px;
        cursor: pointer;
        img {
          margin-right: 10px;
        }
        &.upload_btn {
          background: #f78335;
          img {
            width: 20px;
            height: 20px;
          }
        }
        &.next_btn {
          background: #05644f;
        }
      }
    }
    .ant-form-item-has-error .resume_position_wrapper {
      border-color: #ff7875;
    }
    .resume_position_wrapper {
      border: 1px solid rgba(5, 100, 79, 0.5);
      color: #05644f;
      border-radius: 16px;
      min-height: 38px;
      line-height: 38px;
      padding-left: 24px;
      font-size: 14px;
      cursor: pointer;
      .arrow_icon {
        width: 18px;
        height: 18px;
        top: 15px;
        right: 10px;
        position: absolute;
      }
      .skill_wrapper {
        line-height: normal;
        .skill_item {
          margin-bottom: 8px;
          display: inline-block;
          border-radius: 100px;
          margin-right: 12px;
          padding: 5px 8px;
          font-size: 12px;
          background: rgba(247, 131, 53, 0.1);
          color: #f78335;
        }
      }
    }
    .ant-form-item-explain-error {
      margin-bottom: 24px;
    }
  }
  .process_bar {
    width: 100%;
    height: 4px;
    border-radius: 16px;
    height: 18px;
    border: 1px solid rgba(5, 100, 79, 0.5);
    margin-top: 20px;
    .process_rate {
      width: 56%;
      height: 100%;
      border-radius: 16px;
      background: linear-gradient(278deg, #1f9b7f 0%, #1fd0a9 54%, #0256ff 100%);
    }
  }
  .process_text {
    color: #3d3d3d;
    font-size: 16px;
    padding: 10px 0;
    .process {
      float: right;
    }
  }
  .resume_action_wrapper {
    position: absolute;
    right: -120px;
    bottom: 0;
    background: #b8dfc8;
    box-sizing: border-box;
    border: 1px solid rgba(5, 100, 79, 0.5);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 100px;
    padding: 15px;
    color: #05644f;
    .item {
      text-align: center;
      cursor: pointer;
      border-top: 1px solid rgba(5, 100, 79, 0.25);
      padding: 10px 0;
      &:first-child {
        border-top: none;
      }
      p {
        margin: 10px 0;
      }
    }
  }
}
.error_modal {
  .btn_wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 20px;
  }
  .confirm_icon {
    width: 80px;
    height: 80px;
    margin: 50px auto;
    display: block;
  }
  .confirm_text {
    font-size: 16px;
    font-weight: normal;
    margin: 30px auto;
    color: #3d3d3d;
    text-align: center;
  }
  .confirm_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    display: block;
    flex: 1;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    border: none;
    &.cancel_btn {
      background: rgba(5, 100, 79, 0.3);
      color: #fff;
    }
    &.confirm_btn {
      background: #05644f;
      color: #fff;
    }
  }
}
.resume_select_dropdown {
  background: #fff;
  min-width: 200px !important;
  padding: 10px;
  .ant-select-item {
    color: #05644f;
    background: #fff;
    &:hover,
    &.ant-select-item-option-active,
    &.ant-select-item-option-selected {
      background: rgba(5, 100, 79, 0.1);
      color: #05644f;
    }
  }
  .ant-input {
    border: 1px solid rgba(5, 100, 79, 0.5);
    color: #05644f;
    border-radius: 16px;
    box-shadow: none;
    &::placeholder {
      color: rgba(5, 100, 79, 0.3);
    }
  }
}
.evaluation_modal {
  .ant-modal-content {
    border-radius: 20px;
  }
  .ant-modal-title,
  .ant-modal-header {
    margin-bottom: 0;
  }
  .tips {
    color: #05644f;
    font-size: 16px;
    font-weight: 300;
  }
  .section_wrapper {
    margin: 30px 0;
    .section {
      border: 1px solid rgba(5, 100, 79, 0.3);
      border-radius: 16px;
      padding: 10px 60px 10px 20px;
      position: relative;
      margin: 25px auto;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      color: #05644f;
      .label_icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .arrow_icon {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 10px;
        top: calc(50% - 10px);
      }
      .label_description {
        margin-top: 10px;
        font-size: 12px;
        font-weight: 300;
      }
    }
  }
  .submit_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
    display: block;
    width: 100%;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    cursor: pointer;
    &:hover {
      background: #05644f;
      color: #fff;
    }
    .btn_arrow {
      margin-left: 10px;
      font-size: 18px;
    }
    .btn_icon {
      width: 18px;
      height: 18px;
      margin-left: 10px;
    }
  }
}
</style>

<style scoped lang="less"></style>
